export default "__VITE_ASSET__91e4e020__"